import { forwardRef, HTMLAttributes } from 'react';
import styles from './LoadingDot.module.scss';
import classNames from 'classnames';

export const LoadingDot = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  (props, ref) => {
    return (
      <div ref={ref} className={classNames(styles.root, 'color-primary')}>
        <div />
        <div />
        <div />
      </div>
    );
  }
);

LoadingDot.displayName = 'LoadingDot';
